module.exports = __webpack_public_path__ + "assets/img/zs02.babaf310.png";